import { Component } from "../../base/Component";
import { ensureElement, handlePrice } from "../../../utils/utils";
export class Card extends Component {
    constructor(container, actions) {
        super(container);
        this._title = ensureElement('.card__title', this.container);
        this._price = ensureElement('.card__price', this.container);
        if (actions === null || actions === void 0 ? void 0 : actions.onCardClick) {
            this.container.addEventListener('click', actions.onCardClick);
        }
    }
    set id(value) {
        this.container.dataset.id = value;
    }
    get id() {
        return this.container.dataset.id || '';
    }
    set title(value) {
        this.setText(this._title, value);
    }
    get title() {
        return this._title.textContent || '';
    }
    set price(value) {
        this.setText(this._price, value !== null ? handlePrice(value) + ' синапсов' : 'Бесценно');
    }
}
